{
  "title": "Galerie media",
  "unfiled": "Fără folder",
  "tabs": {
    "gallery": "Galerie",
    "pending": "În așteptare"
  },
  "filters": {
    "filterBy": "Filtrează după",
    "lastUpdated": "Ultima actualizare",
    "dateTaken": "Data realizării",
    "fromDate": "Data de început",
    "toDate": "Data de sfârșit",
    "to": "până la",
    "clear": "Șterge"
  },
  "albums": {
    "all": "Toate ({count})",
    "newFolder": "Folder nou",
    "newAlbum": "Album nou",
    "deleteFolderTitle": "Șterge folderul",
    "pendingPill": "{count} în așteptare",
    "itemCount": "{count} element",
    "itemCountPlural": "{count} elemente",
    "emptyHeading": "Niciun album",
    "emptyMessageCanUpload": "Creează un album pentru a adăuga fotografii și videoclipuri.",
    "emptyMessage": "Nimic aici încă.",
    "modalEditHeading": "Editează albumul",
    "modalNewHeading": "Album nou",
    "nameLabel": "Numele albumului",
    "nameRequired": "Numele albumului este obligatoriu",
    "folderLabel": "Folder",
    "descriptionLabel": "Descriere (opțional)",
    "save": "Salvează albumul",
    "saved": "Album salvat"
  },
  "folders": {
    "modalHeading": "Folder nou",
    "nameLabel": "Numele folderului",
    "nameRequired": "Numele folderului este obligatoriu",
    "created": "Folder creat",
    "create": "Creează folderul",
    "deleteHeading": "Șterge folderul",
    "deleteMessage": "Ștergi folderul „{name}”? Albumele sale sunt păstrate și devin Fără folder.",
    "deleteConfirm": "Șterge folderul"
  },
  "pending": {
    "emptyHeading": "Nimic de verificat",
    "emptyMessage": "Materialele trimise de elevi în așteptarea aprobării vor apărea aici.",
    "unknownUploader": "Necunoscut",
    "approve": "Aprobă",
    "reject": "Respinge",
    "approved": "Aprobat",
    "rejectHeading": "Respinge materialul",
    "rejectMessage": "Respingi „{name}”? Va fi șters, iar elevul va fi notificat. Poți adăuga un motiv mai jos.",
    "rejectConfirm": "Respinge",
    "reasonPlaceholder": "Motiv (opțional, comunicat elevului)"
  },
  "type": {
    "photo": "Fotografie",
    "video": "Video"
  },
  "lightbox": {
    "taken": "Realizat {date}",
    "awaitingApproval": "în așteptarea aprobării",
    "tags": "Etichete",
    "tagPlaceholder": "Caută sau creează o etichetă…",
    "openFull": "Deschide complet",
    "download": "Descarcă",
    "close": "Închide"
  },
  "confirm": {
    "fallback": "Confirmă"
  }
}
